import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=b0c270d4&scoped=true&"
import script from "./Paginator.vue?vue&type=script&lang=ts&"
export * from "./Paginator.vue?vue&type=script&lang=ts&"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=b0c270d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c270d4",
  null
  
)

export default component.exports